__turbopack_context__.v({
  "quoteBlock": "QuoteBox-module-scss-module__0fX6oG__quoteBlock",
  "quoteChange": "QuoteBox-module-scss-module__0fX6oG__quoteChange",
  "quoteData": "QuoteBox-module-scss-module__0fX6oG__quoteData",
  "quoteName": "QuoteBox-module-scss-module__0fX6oG__quoteName",
  "quotePrice": "QuoteBox-module-scss-module__0fX6oG__quotePrice",
});
